import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import LoaderText from '../components/loader/LoaderText';
import BlankLayout from '../layout/BlankLayout';
import Error404 from '../pages/error/Error404';
import RegisterLayout from '../layout/RegisterLayout';
import GuestLayout from '../layout/GuestLayout';
import { NAVIGATE_GUEST } from '../constant';

const HomePage = lazy(() => import('../pages/guest/homepage'));
const PreRegisterPage = lazy(() => import('../pages/guest/pre-register'));
const HealthCampDetails = lazy(() => import('../pages/guest/camp-details/HealthCampDetails'));
const SurveyForm = lazy(() => import('../pages/guest/surveyForm/SurveyForm'));
const SchemeDetailsPage = lazy(() => import('../components/dialog/schemes/SchemesDetailsPage'));
const TermsConditions = lazy(() => import('../pages/guest/terms-condition'));
const PrivacyPolicy = lazy(() => import('../pages/guest/privacy-policy'));
const CopyrightPolicy = lazy(() => import('../pages/guest/copyright-policy'));
const Disclaimer = lazy(() => import('../pages/guest/disclaimer'));
const HyperlinkPolicy = lazy(() => import('../pages/guest/hyperlink-policy'));
const Inauguration = lazy(() => import('../pages/guest/inaugaration'));
const CurtainSlider = lazy(() => import('../pages/guest/inaugaration/Slider'));
const BhajaniMandalForm = lazy(() => import('../pages/guest/bhajani-mandal/BhajaniMandalForm'));
const JatraRegisterPage = lazy(() => import('../pages/admin/jatra/JatraForm'));

const GuestRoute = () => {
    return (
        <Suspense fallback={<BlankLayout><LoaderText /></BlankLayout>}>
            <Routes>
                <Route path='/' element={<Navigate to={NAVIGATE_GUEST.HOME} replace />}></Route>
                <Route path={NAVIGATE_GUEST.HOME} element={<HomePage />}></Route>
                <Route path={NAVIGATE_GUEST.SUREVEY_FORM} element={<RegisterLayout><SurveyForm /></RegisterLayout>}></Route>
                <Route path={NAVIGATE_GUEST.BHAJANI_MANDAL} element={<RegisterLayout><BhajaniMandalForm /></RegisterLayout>}></Route>
                <Route path={NAVIGATE_GUEST.JATRA_REGISTER} element={<RegisterLayout><JatraRegisterPage /></RegisterLayout>}></Route>
                <Route path={NAVIGATE_GUEST.PRE_REGISTER} element={<GuestLayout><PreRegisterPage /></GuestLayout>}></Route>
                <Route path={NAVIGATE_GUEST.GUEST_CAMPAIGN_DETAILS} element={<GuestLayout><HealthCampDetails /></GuestLayout>}></Route>
                <Route path={NAVIGATE_GUEST.SCHEME_DETAILS} element={<GuestLayout><SchemeDetailsPage /></GuestLayout>}></Route>
                <Route path={NAVIGATE_GUEST.TERMS_CONDITIONS} element={<TermsConditions />}></Route>
                <Route path={NAVIGATE_GUEST.PRIVACY_POLICY} element={<PrivacyPolicy />}></Route>
                <Route path={NAVIGATE_GUEST.COPYRIGHT_POLICY} element={<CopyrightPolicy />}></Route>
                <Route path={NAVIGATE_GUEST.DISCLAIMER} element={<Disclaimer />}></Route>
                <Route path={NAVIGATE_GUEST.HYPERLINK_POLICY} element={<HyperlinkPolicy />}></Route>
                <Route path={NAVIGATE_GUEST.INAUGRATION_PAGE} element={<Inauguration />} />
                <Route path={NAVIGATE_GUEST.SLIDER} element={<CurtainSlider />} />

                <Route path='*' element={<Error404 />}></Route>
            </Routes>
        </Suspense>
    );
};

export default GuestRoute;
